export class LoadRelNotificheIN {
}
